import StudentReportView from './component';
import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import is from 'is_js';
import { StudentReportSummary } from 'data/ProgressReports/StudentReportSummaries';
import StudentSelect from './StudentSelect';
import { actions as groupAction } from 'containers/Group';

const SHOW_SUBMIT_FOR_APPROVAL = false;
const SHOW_ADD_COMMENTS = false;

const actionButtons = (getState) => ({
  Submit: {
    isPrimary: true,
    route: './publish',
    label: ({ params: { progressReportId, studentId } }) => {
      try {  // meh.
        return isCommentExist(getState(), progressReportId, studentId) ?
          'Submit for Approval' :
          'Submit';
      } catch (e) {
        return 'Submit';
      }
    },
    disableWhen: ({ params: { progressReportId, studentId, mode } }) =>
      (mode && mode.length) ||  // disable when in `edit` or `add` modes
      ! isPublishable(getState(), progressReportId, studentId),
    visibleWhen: ({ params: { groupId, progressReportId, studentId } }) =>
      SHOW_SUBMIT_FOR_APPROVAL &&
      ! groupAction.isDisabledReportActions(getState(), groupId) &&
      PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressReport.Publish) &&
      ! isFuture(getState(), progressReportId, studentId),
  },
  Export: {
    route: './export',
    visibleWhen: ({ params: { groupId, progressReportId, studentId } }) =>
      ! groupAction.isHFV4CourseTypeGroup(getState(), groupId) &&
      PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressReport.Export) &&
        ! isFuture(getState(), progressReportId, studentId),
    disableWhen: ({ params: { progressReportId, studentId, mode } }) =>
      (mode && mode.length) ||
       ! isExportable(getState(), progressReportId, studentId),
  },
  'Add Comment': {
    route: './add-comment',
    disableWhen: ({ params: { progressReportId, studentId, mode } }) =>
      (mode && mode.length) ||  // disable when in `edit` or `add` modes
      ! isPublishable(getState(), progressReportId, studentId),
    visibleWhen: ({ params: { groupId, progressReportId, studentId } }) =>
      SHOW_ADD_COMMENTS &&
      ! groupAction.isDisabledReportActions(getState(), groupId) &&
      PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressReport.AddComment) &&
          ((! isFuture(getState(), progressReportId, studentId) &&
          ! isCommentExist(getState(), progressReportId, studentId) &&
          ! isCommentPublished(getState(), progressReportId, studentId)) ||
        PrivilegeChecker.hasPrivilege(
            getState(), Privileges.ProgressReport.UpdatePublishedProgressReport)),
  },
});

export const Modes = {
  EXPORT: 'export',
};

export default ({ getState }) => ({
  path: 'student/:studentId(/:mode)',
  component: StudentReportView,
  canAccess: ({ location: { pathname } }) => {
    const isEditMode = pathname.endsWith('/add-comment') || pathname.endsWith('/edit-comment');
    if (! isEditMode) {
      return true;
    }
    return PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressReport.AddComment);
  },
  breadcrumbLabels: 'Student Report',
  actionButtons: {
    default: actionButtons(getState),
    'add-comment': actionButtons(getState),
    'edit-comment': actionButtons(getState),
    [Modes.EXPORT]: actionButtons(getState),
  },
  appBars: {
    sticky: {
      'student-select': {
        component: StudentSelect,
        order: 2,
      },
    },
  },
});

function isFuture(state, progressReportId, studentId) {
  const studentReportSummary = state.get('rootReducer')
    .get('studentReportSummaries')
    .get(`${progressReportId}`)
    .data
    .get(`${studentId}`);
  return is.undefined(studentReportSummary) ||
    is.falsy(studentReportSummary.status);
}

function isPublishable(state, progressReportId, studentId) {
  const studentReportSummary = state.get('rootReducer')
    .get('studentReportSummaries')
    .get(`${progressReportId}`)
    .data
    .get(`${studentId}`);
  return studentReportSummary &&
    studentReportSummary.status === StudentReportSummary.Status.Ready;
}
function isExportable(state, progressReportId, studentId) {
  const studentReportSummary = state.get('rootReducer')
    .get('studentReportSummaries')
    .get(`${progressReportId}`)
    .data
    .get(`${studentId}`);
  return studentReportSummary &&
      (studentReportSummary.status === StudentReportSummary.Status.SentToDoS ||
      studentReportSummary.status === StudentReportSummary.Status.Completed ||
      studentReportSummary.status === StudentReportSummary.Status.Published ||
      studentReportSummary.status === StudentReportSummary.Status.Ready);
}
function isCommentPublished(state, progressReportId, studentId) {
  const studentReportSummary = state.get('rootReducer')
    .get('studentReportSummaries')
    .get(`${progressReportId}`)
    .data
    .get(`${studentId}`);
  return studentReportSummary &&
    (studentReportSummary.status === StudentReportSummary.Status.SentToDoS ||
    studentReportSummary.status === StudentReportSummary.Status.Completed ||
    studentReportSummary.status === StudentReportSummary.Status.Published);
}

function isCommentExist(state, progressReportId, studentId) {
  const studentReportSummary = state.get('rootReducer')
    .get('studentReportSummaries')
    .get(`${progressReportId}`)
    .data
    .get(`${studentId}`);
  if (studentReportSummary &&
    studentReportSummary.comments) {
    return ! is.falsy(studentReportSummary.comments) &&
      studentReportSummary.comments.length > 0;
  }
  return false;
}



// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/StudentReportView/routes.js